import React from 'react';

const publications = [
  {
    title: "Governance of Gilgit Baltistan: Issues and Solutions",
    authors: "Abbas Yasir",
    organisation: "Research Society of International Law",
    year: "2022",
    link: "https://rsilpak.org/2022/governance-of-gilgit-baltistan-issues-and-solutions/",
    description: "An in-depth analysis of governance challenges and proposed solutions for the Gilgit Baltistan region, focusing on legal and policy frameworks."
  },
  {
    title: "Comparative Analysis: Digital Media Regulatory Landscape in Pakistan",
    authors: "Abbas, Yasir",
    organisation: "Media Matters for Democracy",
    year: "2022",
    link: "https://mediamatters.pk/wp-content/uploads/2022/10/Digital-Media-Regulatory-Landscape-in-Pakistan.pdf",
    description: "A comparative study examining the regulatory environment for digital media in Pakistan, highlighting key issues and international best practices."
  },
  {
    title: "Policy Paper on Establishing Formal Alternative Dispute Resolution in Gilgit Baltistan",
    authors: "Abbas, Yasir and Mehsood Fahad",
    organisation: "Legal Aid Society",
    year: "2022",
    link: null, // No link available
    description: "A policy paper proposing the establishment of formal alternative dispute resolution mechanisms to enhance access to justice in Gilgit Baltistan."
  },
  {
    title: "The Impact of Economic Sanctions on Economic and Social Rights in the Islamic Republic of Iran",
    authors: "Abbas, Yasir and William Fuli, Godfry",
    organisation: "Human Rights Law Clinic Papers 2019, and United Nations Office of the High Commissioner for Human Rights",
    year: "2019",
    link: null, // No link available
    description: "Research exploring the effects of economic sanctions on the human rights situation in Iran, with a focus on economic and social rights."
  },
];

const researchAreas = [
  "International Law",
  "International Affairs",
  "Human Rights",
  "Government Relations",
  "Constitutional Law",
  "Governance",
  "Digital Regulation",
  "Dispute Resolution",
  "Democratic Governance"
];

const Publications: React.FC = () => {
  return (
    <section id="publications" className="bg-white section-padding">
      <div className="container-custom">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
            Publications & Research
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <ul className="space-y-4">
            {publications.map((pub, index) => (
              <li key={index} className="flex items-start">
                <span className="text-prestige-600 mr-3 mt-1 text-base">•</span>
                <div className="flex-1">
                  <div className="font-medium text-gray-800 text-base mb-1">{pub.title}</div>
                  <div className="text-gray-600 text-sm mb-1">{pub.authors}</div>
                  <div className="text-gray-600 text-sm mb-1">{pub.organisation}, {pub.year}</div>
                  <div className="text-gray-600 text-xs mb-1">{pub.description}</div>
                  {pub.link && (
                    <a 
                      href={pub.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-prestige-600 hover:text-prestige-700 underline text-xs"
                    >
                      Read Publication
                    </a>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Publications;
